export default "__VITE_ASSET__CTVN40ii__"